import { BaseApiService } from './BaseApiService';
import { AiSqlResult } from '../types/AiSql';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

class AiSqlService extends BaseApiService {
  async runQuestion(question: string): Promise<AiSqlResult> {
    const payload = await this.post<ApiResponse<AiSqlResult>>('/reports/exploration/query', {
      question,
    });

    if (payload?.success && payload.data) {
      return payload.data;
    }

    throw new Error(payload?.message || 'Failed to run AI SQL query');
  }

  async exportCsv(requestId: string): Promise<Blob> {
    const token = localStorage.getItem('token');
    const response = await fetch(`/api/reports/exploration/export/${requestId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to export AI SQL results');
    }

    return response.blob();
  }
}

export const aiSqlService = new AiSqlService();
